import React, { Component } from 'react'
import "../styles/StyledButtonStyle.css"

export default class StyledButton extends Component {
    render() {
        return (
            <button onClick={this.props.onClick} className={`StyledButton ${this.props.className} ${this.props.disabled === 1 ? "disabled" : ""}`}>
                {this.props.children}
            </button>
        )
    }
}
